<template lang="html">
  <div class="contents">
    <h1 v-text="$ml.get('contents.title')"/>
  	<h2></h2>
    <b-row class="mt-4">
      <b-col md="8" offset-md="2" sm="10" offset-sm="1" cols="12">
        <p>{{ $ml.get('contents.sub_title') }}</p>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="8" offset-md="2" sm="10" offset-sm="1" cols="12">
        <b-card-group deck>
          <b-card
            class="feature-card feat-6"
            title="Flyer"
            img-src="static/img/PDF.png"
            align="center">
            <b-card-text>
              <a href="static/pdf/flyer_corr.pdf" target="_blank">Visualizza</a> il flyer per i corrispondenti
            </b-card-text>
          </b-card>
          <b-card
            class="feature-card feat-6"
            title="Manuale APP"
            img-src="static/img/PDF.png"
            align="center">
            <b-card-text>
              <a href="static/pdf/opentracking_manuale.pdf" target="_blank">Visualizza</a> il manuale di OpenTracking®
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'Contenuti visionabili',
      slide: 0,
      sliding: true
    }
  },
  computed: {
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = true
    }
  }
}
</script>

<style lang="css" scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  /*color: #35495E;*/
  color: #225bb5;
}

a:hover {
  text-decoration: none;
  color: #4287f5;
}

.feature-card {
  -webkit-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  -moz-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
}

.feat-4 { max-width: 22%; }

.feat-3 { max-width: 30%; }

.feat-2 { max-width: 47%; }

.feat-1 { max-width: 100%; }

.feat-6 { max-width: 15%; }

@media only screen and (max-width: 1000px) {
  .feat-6 { max-width: 100%; }
}

.card-img {
  padding: .8em;
  opacity: .85;
 }
</style>



// WEBPACK FOOTER //
// src/components/Contents.vue